/*eslint no-unused-vars: 0*/
module.exports = function(loader, module, exports, require, __dirname, __filename) {
  eval(arguments[arguments.length - 1]);
};
